import React from "react";
import { BrowserRouter, HashRouter, Switch } from "react-router-dom";
import { Blank_ScreenProvider } from "../screens/blank/blank-context";
import { TeklifHareketleriStoklar_Screen } from "../screens/teklifhareketleristoklar/teklifhareketleristoklar";
import { Marketing_Dashboard_With_Left_Menu_Screen } from "../screens/marketing_dashboard_with_left_menu/marketing_dashboard_with_left_menu";
import { AnaSayfa_Screen } from "../screens/anasayfa/anasayfa";
import { Sales_Dashboard_With_Left_Menu_Screen } from "../screens/sales_dashboard_with_left_menu/sales_dashboard_with_left_menu";
import { PlasiyerTeklifIskontoEkle_Screen } from "../screens/plasiyerteklifiskontoekle/plasiyerteklifiskontoekle";
import { ProoductDetail_Screen } from "../screens/prooductdetail/prooductdetail";
import { PlasiyerTeklifPage_Screen } from "../screens/plasiyerteklifpage/plasiyerteklifpage";
import { Blank_Screen } from "../screens/blank/blank";
import { Resimler_Screen } from "../screens/resimler/resimler";
import { ExceldenAktar_Screen } from "../screens/exceldenaktar/exceldenaktar";
import { SiparisDurumlari_Screen } from "../screens/siparisdurumlari/siparisdurumlari";
import { SiparisSepetOzet_Screen } from "../screens/siparissepetozet/siparissepetozet";
import { KullaniciSecme_Screen } from "../screens/kullanicisecme/kullanicisecme";
import { CariHesap_Screen } from "../screens/carihesap/carihesap";
import { PlasiyerSiparisDetay_Screen } from "../screens/plasiyersiparisdetay/plasiyersiparisdetay";
import { Profil_Screen } from "../screens/profil/profil";
import { TeklifDurumlari_Screen } from "../screens/teklifdurumlari/teklifdurumlari";
import { PlasiyerHome_Screen } from "../screens/plasiyerhome/plasiyerhome";
import { Signin_Screen } from "../screens/signin/signin";
import { SepetModal_Screen } from "../screens/sepetmodal/sepetmodal";
import { VerificationCode_Screen } from "../screens/verificationcode/verificationcode";
import { KalemNot_Screen } from "../screens/kalemnot/kalemnot";
import { YeniUrunler_Screen } from "../screens/yeniurunler/yeniurunler";
import { LeftMenu_Screen } from "../screens/leftmenu/leftmenu";
import { SiparisOlustur_Screen } from "../screens/siparisolustur/siparisolustur";
import { SiparisLoglari_Screen } from "../screens/siparisloglari/siparisloglari";
import { BildirimOzeti_Screen } from "../screens/bildirimozeti/bildirimozeti";
import { TeklifHareketleri_Screen } from "../screens/teklifhareketleri/teklifhareketleri";
import { YaslandirmaRapor_Screen } from "../screens/yaslandirmarapor/yaslandirmarapor";
import { TeklifOlustur_Screen } from "../screens/teklifolustur/teklifolustur";
import { ResetPassword_Screen } from "../screens/resetpassword/resetpassword";
import { BakiyeSiparisleri_Screen } from "../screens/bakiyesiparisleri/bakiyesiparisleri";
import { PlasiyerTeklifDetay_Screen } from "../screens/plasiyerteklifdetay/plasiyerteklifdetay";
import { TeklifDetay_Screen } from "../screens/teklifdetay/teklifdetay";
import { Signup_Screen } from "../screens/signup/signup";
import { ExceldenSepeteEkleModal_Screen } from "../screens/exceldensepeteeklemodal/exceldensepeteeklemodal";
import { ForgotPassword_Screen } from "../screens/forgotpassword/forgotpassword";
import { KapatilmamisFaturalar_Screen } from "../screens/kapatilmamisfaturalar/kapatilmamisfaturalar";
import { ExcelModal_Screen } from "../screens/excelmodal/excelmodal";
import { Arama_Screen } from "../screens/arama/arama";
import { PlasiyerIskontoEkle_Screen } from "../screens/plasiyeriskontoekle/plasiyeriskontoekle";
import { SiparisDetay_Screen } from "../screens/siparisdetay/siparisdetay";



import LocalStorageService from "../auth/local-storage-service";
import { Redirect } from "../auth/redirect";
import { IAppMode, IAuthType } from "../bootstrapper";
import { NoMatch404 } from "../components/common/no-match-404";
import { Dashboard, ForgotPassword, Login, ResetPassword } from "../components/default_screens/index";
import { KuikaInfo } from "../components/default_screens/kuika-info";
import { MfeLogin } from "../components/mfe/mfe-login";
import { MsalLogin } from "../components/msal/msal-login";
import { MsalRedirect } from "../components/msal/msal-redirect";
import { NotificationRedirect } from "../components/notification/notification-redirect";
import { ScanCompareTest } from "../screens/scan-compare-test";
import { WFMailInteraction } from "../screens/wf-mail-interaction";
import confJson from "../shared/json/conf.json";
import { KMainFunctions } from "../shared/utilty/main-functions";
import { MasterScreenWrapper } from "./master-screen-wrapper";
import { PrivateRoute } from "./private-route";
import { Route } from "./route";

class Blank_Screen_Wrapper extends MasterScreenWrapper {
  protected get anonymousPaths(): string[] { return []; }
  protected get MasterComponent(): React.ComponentType<any> { return Blank_Screen; }
  protected get MasterProvider(): React.ComponentType<any> { return Blank_ScreenProvider; }
  protected renderSwitchWrapper(): React.ReactNode {
    return (
      <Switch>
        <PrivateRoute exact path="/" component={AnaSayfa_Screen} />
        <PrivateRoute exact path="/anasayfa" component={AnaSayfa_Screen} />
        <PrivateRoute exact path="/plasiyerteklifpage" component={PlasiyerTeklifPage_Screen} />
        <PrivateRoute exact path="/exceldenaktar" component={ExceldenAktar_Screen} />
        <PrivateRoute exact path="/siparisdurumlari" component={SiparisDurumlari_Screen} />
        <PrivateRoute exact path="/carihesap" component={CariHesap_Screen} />
        <PrivateRoute exact path="/profil" component={Profil_Screen} />
        <PrivateRoute exact path="/teklifdurumlari" component={TeklifDurumlari_Screen} />
        <PrivateRoute exact path="/yeniurunler" component={YeniUrunler_Screen} />
        <PrivateRoute exact path="/siparisolustur" component={SiparisOlustur_Screen} />
        <PrivateRoute exact path="/yaslandirmarapor" component={YaslandirmaRapor_Screen} />
        <PrivateRoute exact path="/teklifolustur" component={TeklifOlustur_Screen} />
        <PrivateRoute exact path="/bakiyesiparisleri" component={BakiyeSiparisleri_Screen} />
        <PrivateRoute exact path="/kapatilmamisfaturalar" component={KapatilmamisFaturalar_Screen} />
        <PrivateRoute exact path="/arama" component={Arama_Screen} />
      </Switch>
    );
  }
}



export interface IRouterState {}

export type IRouterType = "HashRouter" | "BrowserRouter";

export interface IRouterProps {
  authType: IAuthType;
  routerType?: IRouterType;
  external_access_token?: string;
  external_refresh_token?: string;
  external_user?: string;
  startingScreen?: string;
  appMode?: IAppMode;
  // Allow only screenInput_* props with specific typing
  [key: `screenInput_${string}`]: unknown;
}

declare let window: any;
export class Router extends React.Component<IRouterProps, IRouterState> {
  timerId: any = null;

  private hasNavigatedToStartingScreen: boolean = false;

  componentDidMount = () => {
    // SET LANGUAGE TO HTML BODY
    const lang = LocalStorageService.getUserLanguage();
    if (lang) {
      const fixedLangAttributeValue = lang.replace("_", "-");
      document.body.setAttribute("lang", fixedLangAttributeValue);
    }
    // Handle starting screen navigation for web component apps (only once)
    if (this.props.appMode === "WebComponent" && this.props.startingScreen && !this.hasNavigatedToStartingScreen) {
      this.hasNavigatedToStartingScreen = true;
      this.navigateToStartingScreen();
    }

    window.onfocus = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = true;
    };

    window.onblur = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = false;
    };

    if (!window.styler_speed) {
      window.styler_speed = 20;
    } else if (window.styler_speed < 500) {
      window.styler_speed += 100;
    }

    if (window?.kuika?.activeKuikaComponent !== undefined) {
      return;
    }
    const runTimeout = () => {
      this.timerId = setTimeout(() => {
        const allFormItems: NodeListOf<HTMLElement> = document.querySelectorAll(".kFormItem");
        if (allFormItems) {
          allFormItems.forEach((formItem) => {
            if (formItem.getAttribute("data-display-affected") === "true") {
              return;
            }
            const antFormItemControlInputContent: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input .ant-form-item-control-input-content"
            );
            const antFormItemControlInput: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input"
            );
            const antFormItemControl: HTMLElement = formItem.querySelector(".ant-form-item-control");

            if (
              antFormItemControlInputContent &&
              antFormItemControlInputContent.children &&
              antFormItemControlInputContent.children.length > 0
            ) {
              const formChild: HTMLElement = antFormItemControlInputContent.children[0] as HTMLElement;
              let calculatedDisplay: string = formChild.style.display;
              if (
                calculatedDisplay &&
                antFormItemControl &&
                antFormItemControlInput &&
                antFormItemControlInputContent
              ) {
                if (calculatedDisplay === "inline-flex" || calculatedDisplay === "inline-block") {
                  calculatedDisplay = "";
                  formItem.style.width = formChild.style.width ?? "auto";
                  formItem.style.display = "inline-block";
                  formItem.setAttribute("data-display-affected", "true");
                }
              }
            }
          });
        }
        this.componentDidMount();
      }, window.styler_speed);
    };

    runTimeout();

    setTimeout(() => {
      clearTimeout(this.timerId);
    }, 10000);
  };

  private getScreenInputPropKeys = (): string[] => {
    return Object.keys(this.props || {}).filter((k) => k && k.startsWith("screenInput_"));
  };

  private buildScreenInputsFromProps = (): Record<string, unknown> => {
    const screenInputs: Record<string, unknown> = {};
    this.getScreenInputPropKeys().forEach((key) => {
      const inputName = key.substring("screenInput_".length);
      screenInputs[inputName] = this.props[key];
    });
    return screenInputs;
  };

  private navigateToStartingScreen = () => {
    try {
      const screenName = this.props.startingScreen as string;
      const baseHash = screenName.startsWith("#") ? screenName : `#${screenName}`;
      const inputs = this.buildScreenInputsFromProps();
      const params = new URLSearchParams();

      Object.keys(inputs).forEach((k) => {
        const v = inputs[k];
        if (v !== undefined && v !== null) {
          params.append(k, typeof v === "string" ? v : JSON.stringify(v));
        }
      });

      const qs = params.toString();
      const hash = `${baseHash}${qs ? `?${qs}` : ""}`;

      if (window.location.hash !== hash) {
        window.location.hash = hash;
      }
    } catch (e) {
      console.error("Error navigating to starting screen:", e);
    }
  };

  render() {
    const KuikaRouter = this.KuikaRouter();
    return (
      <>
        <KuikaRouter>
          <Switch key="Switch">
            
                        <Route exact path="/" component={Blank_Screen_Wrapper} />
            <Route path={["/anasayfa", "/plasiyerteklifpage", "/exceldenaktar", "/siparisdurumlari", "/carihesap", "/profil", "/teklifdurumlari", "/yeniurunler", "/siparisolustur", "/yaslandirmarapor", "/teklifolustur", "/bakiyesiparisleri", "/kapatilmamisfaturalar", "/arama"]} component={Blank_Screen_Wrapper} />
            <PrivateRoute exact path="/teklifhareketleristoklar" component={TeklifHareketleriStoklar_Screen} />
            <PrivateRoute exact path="/marketing_dashboard_with_left_menu" component={Marketing_Dashboard_With_Left_Menu_Screen} />
            <PrivateRoute exact path="/sales_dashboard_with_left_menu" component={Sales_Dashboard_With_Left_Menu_Screen} />
            <PrivateRoute exact path="/plasiyerteklifiskontoekle" component={PlasiyerTeklifIskontoEkle_Screen} />
            <PrivateRoute exact path="/prooductdetail" component={ProoductDetail_Screen} />
            <PrivateRoute exact path="/resimler" component={Resimler_Screen} />
            <PrivateRoute exact path="/siparissepetozet" component={SiparisSepetOzet_Screen} />
            <PrivateRoute exact path="/kullanicisecme" component={KullaniciSecme_Screen} />
            <PrivateRoute exact path="/plasiyersiparisdetay" component={PlasiyerSiparisDetay_Screen} />
            <PrivateRoute exact path="/plasiyerhome" component={PlasiyerHome_Screen} />
            <Route exact path="/signin" component={this.LoginComponent()} />
            <Route exact path="/signin" component={Signin_Screen} />
            <PrivateRoute exact path="/sepetmodal" component={SepetModal_Screen} />
            <Route exact path="/verificationcode" component={VerificationCode_Screen} />
            <PrivateRoute exact path="/kalemnot" component={KalemNot_Screen} />
            <PrivateRoute exact path="/leftmenu" component={LeftMenu_Screen} />
            <PrivateRoute exact path="/siparisloglari" component={SiparisLoglari_Screen} />
            <PrivateRoute exact path="/bildirimozeti" component={BildirimOzeti_Screen} />
            <PrivateRoute exact path="/teklifhareketleri" component={TeklifHareketleri_Screen} />
            <Route exact path="/resetpassword" component={ResetPassword_Screen} />
            <PrivateRoute exact path="/plasiyerteklifdetay" component={PlasiyerTeklifDetay_Screen} />
            <PrivateRoute exact path="/teklifdetay" component={TeklifDetay_Screen} />
            <Route exact path="/signup" component={Signup_Screen} />
            <PrivateRoute exact path="/exceldensepeteeklemodal" component={ExceldenSepeteEkleModal_Screen} />
            <Route exact path="/forgotpassword" component={ForgotPassword_Screen} />
            <PrivateRoute exact path="/excelmodal" component={ExcelModal_Screen} />
            <PrivateRoute exact path="/plasiyeriskontoekle" component={PlasiyerIskontoEkle_Screen} />
            <PrivateRoute exact path="/siparisdetay" component={SiparisDetay_Screen} />

            <Route path="/redirect" component={Redirect} />
            <Route path={"/login"} component={this.LoginComponent()} />
            
            
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <Route exact path="/kuikainfo" component={KuikaInfo} />
            <Route exact path="/msalredirect" component={MsalRedirect} />
            <Route exact path="/wfmailinteraction" component={WFMailInteraction} />
            <PrivateRoute exact path="/scancomparetest" component={ScanCompareTest} />
            <Route exact path="/notificationredirect" component={NotificationRedirect} />
            <Route exact path="/logout" component={Redirect} />
            <Route path="*" component={NoMatch404} />
          </Switch>
        </KuikaRouter>
      </>
    );
  }

  KuikaRouter = () => {
    // Web component case
    let isWebComponentApp: any;
    isWebComponentApp = this.props.appMode === "WebComponent";
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app.appName === confJson.applicationName && app.workspace === confJson.domainName) {
          isWebComponentApp = true;
        }
      });
    }
    if (window.kuika === undefined) {
      window.kuika = {};
    }
    window.kuika.isWebComponentApp = isWebComponentApp;

    if (isWebComponentApp === true || this.props.routerType === "HashRouter") {
      return (props: any) => {
        return <HashRouter key="HashRouter">{props.children}</HashRouter>;
      };
    }
    return (props: any) => {
      if (KMainFunctions.virtualDirectoryURL === "auto" || window?.location?.protocol === "file:") {
        return <BrowserRouter key="BrowserRouter">{props.children}</BrowserRouter>;
      }
      return (
        <BrowserRouter basename={KMainFunctions.virtualDirectoryURL} key="BrowserRouter">
          {props.children}
        </BrowserRouter>
      );
    };
  };

  LoginComponent = () => {
    if (this.props.authType === "MSAL") {
      return MsalLogin;
    }

    const { external_access_token } = this.props;
    const { external_refresh_token } = this.props;
    const { external_user } = this.props;
    // The host injects external_access_token as a short-lived MFE handoff JWT.
    // No refresh_token is involved — the microapp's own backend mints its
    // session cookies once the token is redeemed.
    if (external_access_token !== null && external_access_token !== undefined && external_access_token !== "") {
      return (props: any) => {
        return (
          <MfeLogin
            external_user={external_user}
            external_access_token={external_access_token}
            external_refresh_token={external_refresh_token}
          ></MfeLogin>
        );
      };
    }

    if (this.props.authType === "Kuika") {
      return Signin_Screen;
    }
    return <></>;
  };
}
